<template>
  <div>
    <el-card
      class="left-box"
      body-style="height:calc(100vh - 150px);overflow-y:auto;padding:0px 20px;padding-bottom: 0px"
      v-loading="loading"
    >
      <div
        style="
          height: 30px;
          margin-bottom: 10px;
          margin-top: 10px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          justify-content: space-between;
        "
      >
        <!-- <el-input
          style="width: 300px"
          clearable
          v-model="searchData.SupplierName"
          placeholder="请输入供应商名称"
        ></el-input> -->
        <div>
          <el-input
            style="width: 300px; margin-left: 10px"
            v-model="searchData.Device"
            clearable
            placeholder="请输入设备名称/编号"
          ></el-input>
          <el-input
            style="width: 300px; margin-left: 10px"
            v-model="searchData.Accessory"
            clearable
            placeholder="请输入配件名称/编号"
          ></el-input>
          <el-button type="primary" style="margin-left: 10px" @click="Search"
            >查询</el-button
          >
        </div>
        <div style="">
          <span class="Quantity">配件数量小计：{{ TotalQuantity }}</span>
          <span class="Quantity">配件数量总计：{{ SumQuantity }}</span>
        </div>
      </div>
      <div style="width: 100%">
        <el-table height="calc(100vh - 240px)" :data="dataList">
          <el-table-column
            type="index"
            label="序号"
            width="55"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="DeviceCode"
            label="设备编号"
            align="center"
            sortable
          />
          <el-table-column
            prop="DeviceName"
            label="设备名称"
            align="center"
            sortable
          />
          <el-table-column
            prop="AccessoryCode"
            label="配件编号"
            align="center"
            sortable
          />
          <el-table-column
            prop="AccessoryName"
            label="配件名称"
            align="center"
            sortable
          />

          <el-table-column
            prop="TypeName"
            label="配件类型"
            align="center"
            sortable
          />

          <el-table-column
            prop="AccessorySpec"
            label="配件规格"
            align="center"
            sortable
          />
          <el-table-column
            prop="AccessoryNum"
            label="配件数量"
            align="right"
            sortable
          />
          <el-table-column
            prop="SupplierName"
            label="供应商名称"
            align="center"
            sortable
          />
          <el-table-column
            prop="Supplier"
            label="生产厂家名称"
            align="center"
            sortable
          />
        </el-table>
      </div>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataStatistics: {},
      dataList: [],
      searchData: {
        SupplierName: '',
        Device: '',
        Accessory: '',
      },
      loading: false,
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      backName: '',
      pId: '',
      SupplierId: '',
      devId: '',
      SumQuantity: '',
      TotalQuantity: '',
    }
  },
  props: {},
  components: {},
  methods: {
    handleBack() {
      this.$emit('toDom', 'ProjectAll')
    },
    Search() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    getDataList() {
      this.loading = true
      this.$http
        .post(`/PB/PB_Project/GetProjectPanelData`, {
          Panel: 'DeviceAccessoryList',
          ProjectId: this.pId,
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SupplierId: this.SupplierId,
          ...this.searchData,
        })

        .then((res) => {
          this.loading = false
          if (res.Success) {
            this.dataList = res.Data.Data
            this.TotalQuantity = res.Data.TotalQuantity || 0
            this.SumQuantity = res.Data.SumQuantity || 0
            this.pagination.total = res.Data.Total
          } else {
            this.$notify.error(res.Msg)
          }
        })
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
  },
  mounted() {},
  created() {
    this.pId = this.$route.query.id
    this.backName = window.localStorage.getItem('ProjectName') || ''
    this.devId = this.$route.query.devId
    this.SupplierId = this.$route.query.ParentId
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
::v-deep .left-box {
  .el-card__header {
    padding: 10px;
    border: none;
  }
}
::v-deep .con .number {
  color: #e6a23c;
}
.head {
  height: 70px;
  // border-bottom: 1px solid #ccc;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
::v-deep .el-pagination__total {
  font-weight: bold;
  font-size: 18px !important;
}
.Quantity {
  font-weight: bold;
  font-size: 18px;
  margin-right: 20px;
  color: #606266;
}
</style>
